import { TrimDirective } from '@alpha-core/platform-ui';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '../../../../pipes/translate.pipe';
import { PrimeNGModules } from '../../../../shared/alpha-shared.module';

@Component({
    selector: 'app-filter-search-range',
    standalone: true,
    templateUrl: './filter-search-range.component.html',
    styleUrl: './filter-search-range.component.scss',
    imports: [...PrimeNGModules, ReactiveFormsModule, TranslatePipe, TrimDirective],
})
export class FilterSearchRangeComponent {
    @Input() formGroup!: FormGroup;
    @Input() controlName: any;
}
